export default __webpack_public_path__ + "static/media/feather _ message-square.47839271.svg";